<template>
    <div class="card-deal-params-block">
        <el-row v-if="canViewField('complaint_opening_date') && isValueVisible(complaint_opening_date, 'complaint_opening_date')">
            <el-col :span="10">
                <span class="gray">
                    Дата открытия
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField('complaint_opening_date')">
                    <el-date-picker
                        v-model="complaint_opening_date"
                        type="date"
                        placeholder="дд.мм.гггг"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                    />
                    <div class="field-error" v-if="errors.complaint_opening_date" v-text="errors.complaint_opening_date[0]"></div>
                </template>
                <template v-else>
                    {{ complaint_opening_date }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canField(editMode, 'complaint_comment') && isValueVisible(complaint_comment, 'complaint_comment')">
            <el-col :span="10">
                <span class="gray">
                    Комментарий
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode">
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder=""
                        v-model="complaint_comment"
                    />
                </template>
                <template v-else>
                    <div v-format-text="complaint_comment"></div>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'guilty_id') && isValueVisible(guilty_id, 'guilty_id')">
            <el-col :span="10">
                <span class="gray">
                    Кто виноват
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'guilty_id')">
                    <el-select
                        v-model="guilty_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        clearable
                        placeholder="Кто виноват"
                        size="mini"
                    >
                        <el-option v-for="item in guiltyTypes" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                    <div class="field-error" v-if="errors.guilty_id" v-text="errors.guilty_id[0]"></div>
                </template>
                <template v-else>
                    {{ guiltyName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'culprit_id') && isValueVisible(culprit_id, 'culprit_id')">
            <el-col :span="10">
                <span class="gray">
                    Виновник
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'culprit_id')">
                    <el-select
                        v-model="culprit_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        filterable
                        clearable
                        autocomplete
                        placeholder=""
                        size="mini"
                    >
                        <el-option v-for="item in culpritList" :key="item.id" :label="item.name" :value="item.id" :class="isFiredEmployerClass(item.date_fired)" />
                    </el-select>
                    <div class="field-error" v-if="errors.culprit_id" v-text="errors.culprit_id[0]"></div>
                </template>
                <template v-else>
                    {{ culpritName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'complaint_performer_id') && isValueVisible(complaint_performer_id, 'complaint_performer_id')">
            <el-col :span="10">
                <span class="gray">
                    Кто исправляет
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'complaint_performer_id')">
                    <el-select
                        v-model="complaint_performer_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        filterable
                        default-first-option
                        clearable
                        autocomplete
                        placeholder="Кто исправляет"
                        size="mini"
                        @change="handleComplaintPerformerChange"
                        @clear="handleComplaintPerformerClear"
                    >
                        <el-option-group
                            v-for="group in complaintPerformerList"
                            :key="group.label"
                            :label="group.label"
                        >
                            <el-option
                                v-for="item in group.options"
                                :key="item.id"
                                :label="item.name"
                                :value="`${group.type}_${item.id}`"
                            />
                        </el-option-group>
                    </el-select>
                    <div class="field-error" v-if="errors.complaint_performer_id" v-text="errors.complaint_performer_id[0]"></div>
                </template>
                <template v-else>
                    {{ complaintPerformerName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'specialist_payment') && isValueVisible(specialist_payment, 'specialist_payment')">
            <el-col :span="10">
                <span class="gray">
                    Оплата специалисту, руб.
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'specialist_payment')">
                    <auto-numeric
                        v-model="specialist_payment"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.specialist_payment" v-text="errors.specialist_payment[0]"></div>
                </template>
                <template v-else>
                    {{ specialist_payment | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'complaint_materials_provider_id') && isValueVisible(complaint_materials_provider_id, 'complaint_materials_provider_id')">
            <el-col :span="10">
                <span class="gray">
                    Поставщик материалов
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'complaint_materials_provider_id')">
                    <el-select
                        v-model="complaint_materials_provider_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        filterable
                        default-first-option
                        clearable
                        autocomplete
                        placeholder="Поставщик материалов"
                        size="mini"
                        @change="handleComplaintPerformerChange"
                        @clear="handleComplaintPerformerClear"
                    >
                        <el-option-group
                            v-for="group in complaintPerformerList"
                            :key="group.label"
                            :label="group.label"
                        >
                            <el-option
                                v-for="item in group.options"
                                :key="item.id"
                                :label="item.name"
                                :value="`${group.type}_${item.id}`"
                                :class="isFiredEmployerClass(item.date_fired)"
                            />
                        </el-option-group>
                    </el-select>
                    <div class="field-error" v-if="errors.complaint_materials_provider_id" v-text="errors.complaint_materials_provider_id[0]"></div>
                </template>
                <template v-else>
                    {{ complaintMaterialsProviderName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canField(editMode, 'complaint_materials_cost') && isValueVisible(complaint_materials_cost, 'complaint_materials_cost')">
            <el-col :span="10">
                <span class="gray">
                    Сумма материалов, руб
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode">
                    <auto-numeric
                        v-model="complaint_materials_cost"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.complaint_materials_cost" v-text="errors.complaint_materials_cost[0]"></div>
                </template>
                <template v-else>
                    {{ complaint_materials_cost | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canField(editMode, 'complaint_amount') && isValueVisible(complaint_amount, 'complaint_amount')">
            <el-col :span="10">
                <span class="gray">
                    Итоговая сумма, руб
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode">
                    <auto-numeric
                        v-model="complaint_amount"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.complaint_amount" v-text="errors.complaint_amount[0]"></div>
                </template>
                <template v-else>
                    {{ complaint_amount | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'complaint_photo') && isValueVisible(complaint_photo, 'complaint_photo')">
            <el-col :span="editMode ? 8: 10">
                <span class="gray">
                    Фото объекта
                </span>
            </el-col>
            <el-col :span="2" v-if="editMode && canEditField( 'complaint_photo')">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleChangeComplaint"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="uploadFileComplaintList"
                    :show-file-list="false"
                    multiple
                    accept="image/*"
                >
                    <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                </el-upload>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'complaint_photo')">
                    <el-tag
                        v-for="file in uploadFileComplaintList"
                        :key="file.name"
                        closable
                        :type="''"
                        @close="handleCloseComplaint(file)"
                        @click.native="handleTagClickComplaint(file)"
                        class="pointer"
                        size="mini"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                    <div class="field-error" v-if="errors.complaint_photo" v-text="errors.complaint_photo[0]"></div>
                </template>
                <template v-else>
                    <el-tag
                        v-for="file in complaint_photo"
                        :key="file.id"
                        :type="''"
                        size="mini"
                        class="pointer"
                        @click.native="handleTagClickComplaint(file)"
                        :disable-transitions="false"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'act_photo') && isValueVisible(act_photo, 'act_photo')">
            <el-col :span="editMode ? 8: 10">
                <span class="gray">
                    Фото акта
                </span>
            </el-col>
            <el-col :span="2" v-if="editMode && canEditField( 'act_photo')">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleChangeAct"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="uploadFileActList"
                    :show-file-list="false"
                    multiple
                    accept="image/*"
                >
                    <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                </el-upload>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'act_photo')">
                    <el-tag
                        v-for="file in uploadFileActList"
                        :key="file.name"
                        closable
                        :type="''"
                        @close="handleCloseAct(file)"
                        @click.native="handleTagClickAct(file)"
                        class="pointer"
                        size="mini"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                    <div class="field-error" v-if="errors.act_photo" v-text="errors.act_photo[0]"></div>
                </template>
                <template v-else>
                    <el-tag
                        v-for="file in act_photo"
                        :key="file.id"
                        :type="''"
                        size="mini"
                        class="pointer"
                        @click.native="handleTagClickAct(file)"
                        :disable-transitions="false"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'complaint_closing_date') && isValueVisible(complaint_closing_date, 'complaint_closing_date')">
            <el-col :span="10">
                <span class="gray">
                    Дата закрытия рекламации
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'complaint_closing_date')">
                    <el-date-picker
                        v-model="complaint_closing_date"
                        type="date"
                        placeholder="дд.мм.гггг"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                    />
                    <div class="field-error" v-if="errors.complaint_closing_date" v-text="errors.complaint_closing_date[0]"></div>
                </template>
                <template v-else>
                    {{ complaint_closing_date }}
                </template>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { cardMixin } from '@/mixins/card';
import FileSaver from 'file-saver';
import { pickerOptions } from '@/common/pickerOptions';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'Complaint',
    mixins: [
        cardMixin
    ],
    data() {
        return {
            uploadFileComplaintList: [],
            uploadFileActList: [],
            pickerOptions
        };
    },
    computed: {
        guiltyName() {
            return this.$store.state.deals.current.guilty ? this.$store.state.deals.current.guilty.name : '';
        },
        complaintPerformerName() {
            const data = this.$store.state.deals.current.complaint_performer;
            return data ? data.name || data.full_name : '';
        },
        complaintMaterialsProviderName() {
            const data = this.$store.state.deals.current.complaint_performer;
            return data ? data.name || data.full_name : '';
        },
        culpritName() {
            const data = this.$store.state.deals.current.culprit;
            return data ? data.name || data.full_name : '';
        },
        factoriesList() {
            return this.$store.state.references.factories;
        },
        guiltyTypes() {
            return this.$store.state.references.guilty;
        },
        installerList() {
            return this.$store.state.references.installers;
        },
        measurerList() {
            return this.$store.state.references.measurers;
        },
        culpritList() {
            if (this.guilty_id === localReferences.complaintGuilty.factory) {
                return this.factoriesList;
            }
            if (this.guilty_id === localReferences.complaintGuilty.measurer) {
                if (this.canViewDateFired) {
                    return this.filterFiredEmployers(this.measurerList);
                }
                return this.measurerList;
            }
            if (this.guilty_id === localReferences.complaintGuilty.installer) {
                if (this.canViewDateFired) {
                    return this.filterFiredEmployers(this.installerList);
                }
                return this.installerList;
            }
            return this.responsibleList;
        },
        complaintPerformerList() {
            return [
                {
                    label: 'Сервис',
                    type: 'service',
                    options: this.getServices()
                },
                {
                    label: 'Производство',
                    type: 'factory',
                    options: this.$store.state.references.factories
                },
                {
                    label: 'Установщики',
                    type: 'installer',
                    options: this.getInstallers()
                }
            ];
        },
        complaint_opening_date: {
            get() {
                return this.$store.state.deals.current.complaint_opening_date;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'complaint_opening_date', value });
            }
        },
        complaint_amount: {
            get() {
                return this.$store.state.deals.current.complaint_amount;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'complaint_amount', value });
            }
        },
        guilty_id: {
            get() {
                return this.$store.state.deals.current.guilty_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'guilty_id', value });
            }
        },
        culprit_id: {
            get() {
                return this.$store.state.deals.current.culprit_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'culprit_id', value });
            }
        },
        complaint_performer_id: {
            get() {
                if (this.$store.state.deals.current.complaint_performer_type === null ||
                    this.$store.state.deals.current.complaint_performer_id === null) {
                    return null;
                }
                return this.$store.state.deals.current.complaint_performer_type + '_' + this.$store.state.deals.current.complaint_performer_id;
            },
            set(value) {
                const complaintPerformerId = value ? value.split('_')[1] : null;
                this.$store.commit('deals/setCurrentField', { field: 'complaint_performer_id', value: complaintPerformerId });
            }
        },
        complaint_materials_provider_id: {
            get() {
                if (this.$store.state.deals.current.complaint_performer_type === null ||
                    this.$store.state.deals.current.complaint_materials_provider_id === null) {
                    return null;
                }
                return this.$store.state.deals.current.complaint_performer_type + '_' + this.$store.state.deals.current.complaint_materials_provider_id;
            },
            set(value) {
                const complaintMaterialsProviderId = value ? value.split('_')[1] : null;
                this.$store.commit('deals/setCurrentField', { field: 'complaint_materials_provider_id', value: complaintMaterialsProviderId });
            }
        },
        specialist_payment: {
            get() {
                return this.$store.state.deals.current.specialist_payment;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'specialist_payment', value });
            }
        },
        complaint_materials_cost: {
            get() {
                return this.$store.state.deals.current.complaint_materials_cost;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'complaint_materials_cost', value });
            }
        },
        complaint_comment: {
            get() {
                return this.$store.state.deals.current.complaint_comment;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'complaint_comment', value });
            }
        },
        complaint_closing_date: {
            get() {
                return this.$store.state.deals.current.complaint_closing_date;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'complaint_closing_date', value });
            }
        },
        complaint_photo: {
            get() {
                return this.$store.state.deals.current.complaint_photo;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'complaint_photo', value });
            }
        },
        act_photo: {
            get() {
                return this.$store.state.deals.current.act_photo;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'act_photo', value });
            }
        },
        services() {
            return this.$store.state.references.services;
        }
    },
    methods: {
        handleExceed() {
            this.$message({
                showClose: true,
                message: 'Внимание, лимит 10 файлов!',
                type: 'warning',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        handleChangeComplaint(file, fileList) {
            this.uploadFileComplaintList = fileList;
            this.$store.commit('deals/setCurrentField', { field: 'complaint_photo', value: [...this.uploadFileComplaintList] });
        },
        handleCloseComplaint(tag) {
            this.uploadFileComplaintList.splice(this.uploadFileComplaintList.indexOf(tag), 1);
            this.$store.commit('deals/setCurrentField', { field: 'complaint_photo', value: [...this.uploadFileComplaintList] });
        },
        handleTagClickComplaint(tag) {
            if (!tag.id) {
                return;
            }
            this.$store.dispatch('deals/getPhoto', { block: 'complaint', id: tag.id })
                .then(response => {
                    FileSaver(new Blob([response.data], { type: tag.type }), tag.name);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        handleChangeAct(file, fileList) {
            this.uploadFileActList = fileList;
            this.$store.commit('deals/setCurrentField', { field: 'act_photo', value: [...this.uploadFileActList] });
        },
        handleCloseAct(tag) {
            this.uploadFileActList.splice(this.uploadFileActList.indexOf(tag), 1);
            this.$store.commit('deals/setCurrentField', { field: 'act_photo', value: [...this.uploadFileActList] });
        },
        handleTagClickAct(tag) {
            if (!tag.id) {
                return;
            }
            this.$store.dispatch('deals/getPhoto', { block: 'act', id: tag.id })
                .then(response => {
                    FileSaver(new Blob([response.data], { type: tag.type }), tag.name);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        handleComplaintPerformerChange(value) {
            const complaintPerformerType = value ? value.split('_')[0] : null;
            this.$store.commit('deals/setCurrentField', { field: 'complaint_performer_type', value: complaintPerformerType });
        },
        handleComplaintPerformerClear() {
            this.complaint_performer_id = null;
            this.$store.commit('deals/setCurrentField', { field: 'complaint_performer_type', value: null });
        },
        getInstallers() {
            if (this.canViewDateFired) {
                return this.filterFiredEmployers(this.$store.state.references.installers);
            }
            return this.$store.state.references.installers;
        },
        getServices() {
            if (this.canViewDateFired) {
                return this.filterFiredEmployers(this.services);
            }
            return this.services;
        }
    },
    watch: {
        complaint_photo: {
            handler(value) {
                if (this.uploadFileComplaintList && value.length) {
                    this.uploadFileComplaintList = [...value];
                }
            },
            deep: true
        },
        act_photo: {
            handler(value) {
                if (this.uploadFileActList && value.length) {
                    this.uploadFileActList = [...value];
                }
            },
            deep: true
        },
        guilty_id(newValue, oldValue) {
            if (newValue && oldValue) {
                this.complaint_performer_id = null;
                this.culprit_id = null;
            }
        }
    },
    mounted() {
        if (this.uploadFileComplaintList && this.uploadFileComplaintList.length === 0 && this.complaint_photo.length) {
            this.uploadFileComplaintList = [...this.complaint_photo];
        }
        if (this.uploadFileActList && this.uploadFileActList.length === 0 && this.act_photo.length) {
            this.uploadFileActList = [...this.act_photo];
        }
    }
};
</script>
